

















































































import Vue from 'vue';

export default Vue.extend({
  props: {
    focusedSection: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    sectionIndex: {
      type: Number,
      required: true,
    },
    sectionData: {
      type: Object,
      required: true,
    },
    sectionConfig: {
      type: Object,
      required: true,
    },
    styles: {
      type: String,
      default: '',
    },
    sectionKey: {
      type: String,
      required: true,
    },
    validated: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    saveSection(data: any) {
      // console.log('SAVE', data);
      this.$emit('save', this.sectionKey, data);
    },
    onClick() {
      if (!this.disabled) {
        this.$emit('press', this.sectionKey);
      }
    },
    focus() {
      if ((this.$refs?.comp as any)?.focus) {
        (this.$refs.comp as any).focus();
      }
    },
    getContainerStyle() {
      const styles = ['section', 'ba b--light-gray w-100'];
      if (this.focusedSection === this.sectionKey) {
        styles.push('focused');
      }
      if (this.sectionIndex === 0) {
        styles.push('br3 br--top');
      } else if (this.sectionIndex === 3) {
        styles.push('br3 br--bottom');
      }

      if (this.sectionIndex === -1) {
        styles.push('br3');
      } else if (this.sectionIndex !== 0) {
        styles.push('bt-0 br0');
      }
      if (!this.disabled) {
        styles.push('pointer');
      }
      styles.push(this.styles);
      return styles.join(' ');
    },
  },
});
